import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let statusPromise = null;
const mapsStatus = () => {
  statusPromise ||= api.get("/asv/geo/status").then((r) => r.data.enabled).catch(() => false);
  return statusPromise;
};

export const useMapsEnabled = () => {
  const [on, setOn] = useState(false);
  useEffect(() => { mapsStatus().then(setOn); }, []);
  return on;
};

export const browserLocation = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error("Location is not available on this device"));
  navigator.geolocation.getCurrentPosition((p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
    () => reject(new Error("Location permission was denied")), { timeout: 10000, maximumAge: 600000 });
});

export const geocode = (q) => api.get("/asv/geo/search", { params: { q } }).then((r) => r.data);

export const placeLabel = (lat, lng) => api.get("/asv/geo/reverse", { params: { lat, lng } }).then((r) => r.data.label).catch(() => "");

export const usePlaceLabel = (lat, lng, enabled) => {
  const [label, setLabel] = useState("");
  useEffect(() => {
    if (!enabled || !lat || !lng) { setLabel(""); return; }
    placeLabel(lat, lng).then(setLabel);
  }, [lat, lng, enabled]);
  return label;
};
